<div [ngClass]="modelValue==-1 ? 'btn-partial' : modelValue==1 ? 'btn-enabled' : 'btn-disabled'" class="tw-toggle mr-1">
  <input [attr.disabled]="disabled ? 'disabled' : null" style="left: 0;" (click)="click(0)" type="radio" name="toggle"
         value="0">
  <label style="left: -4px; top: -9px" [ngClass]="modelValue==0 ? 'btn-disabled' : ''">
    <sb-icon icon="cancel" class="icon-in-btn"></sb-icon>
  </label>
  <input [attr.disabled]="disabled ? 'disabled' : null" style="left: 20px;" (click)="click(-1)" type="radio"
         name="toggle" value="-1">
  <label style="left: 20px;" [ngClass]="modelValue==-1 ? 'btn-partial' : ''"> </label>
  <input [attr.disabled]="disabled ? 'disabled' : null" style="left: 40px;" (click)="click(1)" type="radio"
         name="toggle" value="1">
  <label style="left: 36px; top:-9px" [ngClass]="modelValue==1 ? 'btn-enabled' : ''">
    <sb-icon class="icon-in-btn" icon="checked"></sb-icon>
  </label>
  <span></span>
</div>
<span class="font-weight-normal" style="font-size: 1rem"><ng-content></ng-content></span>
